import React, { ReactNode, type FC } from "react";

export type ContactListProps = {
  children?: ReactNode;
};

export const ContactList: FC<ContactListProps> = ({ children }) => {
  return <div>{children}</div>;
};
